export default function ForgotPasswordTemplate(data) {
    //language=HTML
    return `
        <div class="reset vh-100 d-flex justify-content-center align-items-center">
            <div class="text-center">
                <h2 class=" text-white mb-1">${data.translateId("resetPassword")}</h2>
                <div class=" bg-white p-4">
                    <form>
                        <div class="form-group mb-3">
                            <label for="userName">
                                <i class="fas fa-user"></i>
                            </label>
                            <input type="text" id="userName" class=" form-control py-4" placeholder='${data.translateId("userName")}'>
                        </div>
                        <div class="form-group mb-3">
                            <label for="email">
                                <i class="fas fa-envelope"></i>
                            </label>
                            <input type="text" id="email" class=" form-control py-4" placeholder='${data.translateId("email")}'>
                        </div>
                        <div class="form-group mb-3">
                            <label for="phoneNumber">
                                <i class="fas fa-mobile-screen-button"></i>
                            </label>
                            <input type="text" id="phoneNumber" class=" form-control py-4" placeholder='${data.translateId("phoneNumber")}'>
                        </div>
                        <div>
                            <p>${data.translateId("selectSendCodeMethod")}</p>
                            <div class="sent_code d-flex justify-content-around align-items-center flex-column-reverse flex-md-row border py-3 mb-4">
                                <div class="form-group mb-0">
                                    <input type="radio" id="mail" name="select" class="k-radio k-radio-md" checked>
                                    <label class=" mb-0" for="mail">

                                        <div class=" d-flex justify-content-center">
                                            <span>${data.translateId("Email")}</span>
                                            <i class="pr-2 fa-2x fa fa-envelope"></i>
                                        </div>
                                    </label>

                                </div>
                                <div class="form-group mb-3 mb-md-0">
                                    <input type="radio" id="mobileNumber" name="select" class="k-radio k-radio-md">
                                    <label class=" mb-0" for="mobileNumber">
                                        <div class=" d-flex justify-content-center">
                                            <span>${data.translateId("phoneNumber")}</span>
                                            <i class="pr-2 fa-2x fa fa-mobile-screen-button"></i>
                                        </div>
                                    </label>

                                </div>
                            </div>
                        </div>
                        <button type="submit" id="send" class=" btn btn-block btn-primary py-3">${data.translateId("send")}</button>
                    </form>
                </div>
                <div class="back_login mt-2">
                    <a href="erp5.html#"
                       class=" d-flex justify-content-end align-items-center text-white"><span>${data.translateId("backToLogin")}</span>
                        <i class="fa-solid fa-arrow-left-long pr-2"></i></a>
                </div>
            </div>
        </div>`;
}